type Props = {
  className?: string;
  discountPercentage?: string;
  originalPrice?: string;
  price: string;
  singleRow?: boolean;
  type?: string;
};

export const MoneyTable = function MoneyTable({
  className = "",
  discountPercentage,
  originalPrice,
  price,
  singleRow = false,
  type = "usd",
}: Props) {
  return (
    <div
      className={`checkout-money-table ${
        singleRow ? "single-row" : ""
      } ${className}`}
    >
      <span className="checkout-money-table-values">
        {originalPrice && (
          <span className="checkout-amount-value checkout-amount-value-original">
            <span className="sr-only">original price</span>{" "}
            <s>{originalPrice}</s>
          </span>
        )}
        {price && (
          <span className="checkout-amount-value checkout-amount-value-discounted">
            {originalPrice && <span className="sr-only">discounted price</span>}
            {price}
          </span>
        )}
      </span>

      <span className="checkout-money-table-type">
        {type === "cart" && <span className="checkout-amount-type">cart</span>}
        {type === "usd" && (
          <abbr className="checkout-amount-type" title="U.S. dollar">
            usd
          </abbr>
        )}
      </span>

      {discountPercentage && (
        <div className="checkout-money-table-percentage">
          <div className="checkout-amount-percentage">
            {discountPercentage} discount
          </div>
        </div>
      )}
    </div>
  );
};
